import { navigate } from '../app/navigation'

export function Link({
  to,
  className,
  children,
  ariaLabel,
  role,
}: {
  to: string
  className?: string
  children: React.ReactNode
  ariaLabel?: string
  role?: React.AriaRole
}) {
  return (
    <a
      href={to}
      className={className}
      aria-label={ariaLabel}
      role={role}
      onClick={(event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
        event.preventDefault()
        navigate(to)
      }}
    >
      {children}
    </a>
  )
}